import { useEffect, useRef } from 'react'

const PIXEL_ID = '1937781203594803'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

let initialized = false

/** Inject the official Meta Pixel snippet (once) and fire the initial PageView. */
export function initPixel() {
  if (typeof window === 'undefined' || initialized) return
  initialized = true

  /* Standard Meta Pixel bootstrap snippet */
  ;(function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      ;(b.head || b.body || b.documentElement).appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )

  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')

  /* <noscript> fallback for crawlers / no-JS environments */
  if (!document.getElementById('fb-pixel-noscript')) {
    const noscript = document.createElement('noscript')
    noscript.id = 'fb-pixel-noscript'
    const img = document.createElement('img')
    img.height = 1
    img.width = 1
    img.style.display = 'none'
    img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
    noscript.appendChild(img)
    document.body.appendChild(noscript)
  }
}

/** Fire a standard Meta Pixel event (PageView, ViewContent, Lead, InitiateCheckout, Purchase, etc.). */
export function track(event: string, data?: any) {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', event, data)
}

/** Fire a custom (non-standard) Meta Pixel event. */
export function trackCustom(name: string, data?: any) {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('trackCustom', name, data)
}

/**
 * Light global wiring. The primary CTAs fire explicit events, so this only
 * guarantees the pixel is ready. Reserved for future global listeners.
 */
export function setupGlobalTracking() {
  if (typeof window === 'undefined') return
  if (!window.fbq) initPixel()
}

export function useSectionView(name: string, threshold = 0.3) {
  const ref = useRef<HTMLElement | null>(null)
  useEffect(() => {
    if (!ref.current) return
    const el = ref.current
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          track('ViewContent', { content_name: name })
          observer.disconnect()
        }
      },
      { threshold },
    )
    observer.observe(el)
    return () => observer.disconnect()
  }, [name, threshold])
  return ref
}
